import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import AuthNavbar from '../navigation/authnavigation.jsx';

import CardRequestComp from './requestcardcomp.jsx';
const mapStateToProps = state =>
    ({
        optionState: state.selectedTabReducer.selectedTabReducer,
        cardState: state.getCardReducer.cardState,
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
    })

class RequestCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem('taboption') || "tab5"
        }
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    componentWillMount() {
        this.props.fetchSelectedTab(this.state.selectedOption)
    }
    componentDidMount() {
        localStorage.setItem("comp", "profilecomp")
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
     
    //     let _this = this
    //     setTimeout(function () {
    //         if (publicKey.status === 200) {
    //             const public_Key = publicKey.body.publickey;
    //             let encrypt = new JSEncrypt();
    //             encrypt.setPublicKey(public_Key);


    //             const state = {
    //                 applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex' ,
    //                 accountId: encrypt.encrypt(localStorage.getItem("accountId"))
    //             }
    //             _this.props.fetchCard(state)

    //         }
    //     }, 500);


     }
    // componentWillReceiveProps(nextProps) {
    //     try {
    //         if (nextProps.cardState && nextProps.cardState.length !== 0) {
    //             var filteredR = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "R")
    //             })
    //             var filteredG = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "G")
    //                 
    //             })
    //             var filteredA = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "A")
    //                 
    //             })

    //             var filteredCards = filteredR.concat(filteredG)
    //             this.setState({
    //                 filteredCards: filteredCards[0].cardType
    //             }, () => {
    //                
    //             })
    //         }
    //     } catch (e) {

    //     }

    // }
    callBack() {
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
    }

    render() {      
       
        var cardTypes = localStorage.getItem('cardTypes')
      
        return (
            <div  className="row">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
                <div className="col-md-12 m-0 p-0">
                    <AuthNavbar />
                </div>

                <div className="container" style={{ }}>
                    <div className="row pb-5">
                        <CardRequestComp />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestCard);


// WEBPACK FOOTER //
// ./src/components/myprofile/requestcard.jsx